import { History, LocationState } from 'history';
import queryString from 'querystring';
import React, { useState } from 'react';
import Spinner from '../../components/Spinner';
import { useFetchData } from '../../hooks/useFetchData';
import { fetchUserVerificationState } from '../../modules/AnchorAPI/user/fetchUserVerificationState';
import { UserVerificationState } from '../../modules/AnchorAPI/user/verifyUserEmail';
import { EmailVerifier } from './EmailVerifier';
import * as styles from './styles.sass';

type Props = {
  location: Location;
  history: History<LocationState>;
};

type VerificationStateResponse = {
  userId: number;
  userVerificationState: UserVerificationState;
};

export function VerifyUserEmailScreen({ history, location }: Props) {
  const qs = queryString.parse(location.search.slice(1));
  // Component re-renders and loses its query string.
  // useState preserves it across re-renders.
  const [code] = useState(Array.isArray(qs.code) ? qs.code[0] : qs.code);

  const { state } = useFetchData<{}, VerificationStateResponse>({
    fetchFunction: fetchUserVerificationState,
  });
  const {
    json: { userVerificationState, userId },
    status,
  } = state;

  // User is not logged in
  if (status === 'error') {
    return redirectTo('login');
  }

  if (status === 'loading') return <Spinner color="gray" />;
  if (isVerified()) {
    return redirectTo('dashboard');
  }
  return (
    <div className={styles.screen}>
      <EmailVerifier
        code={code}
        userId={userId}
        userVerificationState={userVerificationState}
      />
    </div>
  );

  function redirectTo(target: 'dashboard' | 'login') {
    switch (target) {
      case 'dashboard':
        history.replace('/');
        return null;
      default:
      case 'login':
        history.replace(
          `/login?return_to=${encodeURI(location.pathname + location.search)}`
        );
        return null;
    }
  }

  function isVerified() {
    return ['verified', 'legacyOrSocialSignOnUser'].includes(
      userVerificationState
    );
  }
}
